<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>
{{leftPart}}<a (click)="callAction($event)" class="embedded-link">{{middlePart}}</a>{{rightPart}}